import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { forwardRef } from 'react';
const defaultVariant = 'h1';
export const PentairTitles = forwardRef((props, forwardedRef) => {
    const { variant, primary, secondary, primaryColor, secondaryColor, ...rootProps } = props;
    return (_jsxs(Box, { ...rootProps, ref: forwardedRef, children: [_jsx(Typography, { variant: variant || defaultVariant, color: primaryColor || 'primary', children: primary }), _jsx(Typography, { variant: variant || defaultVariant, color: secondaryColor || 'secondary', fontWeight: 300, children: secondary })] }));
});
